import Button from "../../../components/Button";
import router from "next/router";
import Link from "next/link";
import useTranslation from "next-translate/useTranslation";

export default function DailyNotMember() {
  const { t } = useTranslation("common");

  return (
    <div className="flex flex-col justify-center items-center space-y-4">
      <div className="font-medium mb-3">
        {t("Please log in to play Daily chess")}
      </div>
      <Link href={"/signIn"}>
        <div className="w-40 flex justify-center border-2 border-red-500 py-2 px-4 rounded-md text-red-500 hover:opacity-70">
          {t("Log in")}
        </div>
      </Link>
      <Button className="w-40" onClick={() => router.push("/register")}>
        {t("Sign up")}
      </Button>
    </div>
  );
}
